import React from "react";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from "@mui/material/Switch";
import Tooltip from '@mui/material/Tooltip';
import { InputContextType } from './GenericInput';

let boolControlCounter = 0;

export interface IBooleanInputChangeEvent {
  (value: boolean): void;
}

export interface IBooleanInputProps {
  value: boolean;
  label: string;
  disabled?: boolean;
  loading?: boolean;
  helpText?: string;
  hint?: string;
  context?: InputContextType;
  swapLabel?: boolean;
  onChange?: IBooleanInputChangeEvent;
};

export interface IBooleanInput extends React.Component {
  inputId: string;
}

class BooleanInput extends React.Component<IBooleanInputProps> implements IBooleanInput {
  inputId = "";

  static defaultProps: IBooleanInputProps = {
    value: false,
    label: "Boolean Input",
    disabled: false,
    loading: false,
    helpText: "",
    hint: "",
    context: InputContextType.normal,
    swapLabel: false
  }

  constructor(props: Readonly<IBooleanInputProps> | IBooleanInputProps) {
    super(props);
    this.inputId = `zeon-boolean-control-${boolControlCounter++}`;
  };

  renderHelpTextElement(): React.ReactNode {
    return <span style={{ fontSize: 'x-small' }}>{this.props.helpText || " "}&nbsp;</span>;
  };

  render() {
    return (
      <Tooltip title={this.props.hint} arrow>
        <FormGroup aria-label={this.props.label} row>
          <FormControlLabel
            value={this.props.label}
            label={this.props.label}
            labelPlacement={this.props.swapLabel ? "start" : "end"}
            control={
              <Switch
                color={
                  this.props.disabled || this.props.loading ? "secondary" : (
                    (this.props.context === InputContextType.error ? "error" :
                      (this.props.context === InputContextType.warning ? "warning" :
                        (this.props.context === InputContextType.info ? "primary" : "secondary"))))
                }
                onClick={() => {
                  if (this.props.onChange) this.props.onChange(!this.props.value);
                }}
                checked={this.props.value}
                disabled={this.props.disabled || this.props.loading}
              />
            }
          />
          <span style={{ fontSize: 'x-small' }}>{this.props.helpText || " "}&nbsp;</span>
        </FormGroup>
      </Tooltip>
    );
  }
}

export default BooleanInput;